var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"szg page"},[_c('Header'),_c('Cards',{ref:"szgCards"}),_c('SectionFeatures'),_c('Demo',{ref:"szgDemo"}),_c('Download'),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }